import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const menuUserAtom = atom({ key: 'menuUserAtom', default: [], effects_UNSTABLE: [persistAtom] });